import { Component, ViewChild } from '@angular/core';

// import { MyPagePage } from '../mypage/mypage';
//import { LocationPage } from '../location/location';
import { RecommendPage } from '../recommend/recommend';
import { FavoritesPage } from '../favorites/favorites';
import { RankingPage } from '../ranking/ranking';
import { OrderHistoryPage } from '../order-history/order-history';
import { SendOrderPage } from '../send-order/send-order';
import { GridPage } from '../grid/grid';
import { LoginPage } from '../login/login';
import { MenulistPage } from '../menulist/menulist';
import { MenulayoutsPage } from '../menulayouts/menulayouts';
import { Localization } from '../../app/app.localization'
import { Config } from  '../../app/app.config';
import { CommercePage } from '../commerce/commerce';
import { Tabs } from 'ionic-angular';
import { ResendMailPage } from '../resend-mail/resend-mail';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  @ViewChild('tabs') tabRef: Tabs;

  tab1Root = RecommendPage;
  tab2Root = RankingPage;
  tab3Root = FavoritesPage;
  tab4Root = OrderHistoryPage;
  tab5Root = SendOrderPage;
  tab6Root = GridPage;
  tab7Root = LoginPage;
  tab8Root = MenulayoutsPage;
  tab9Root = MenulistPage;
  tab10Root = CommercePage;
  tab11Root = ResendMailPage;

  showHistory = true;
  useFixedLayout = false;
  showCommerce = false;
  showResendMail = false;

  ionViewDidEnter() {
      // 店内でpaygentの支払いを中断した際に注文履歴画面を表示する
      if (localStorage.getItem("stopPaymentByInStore") === '1') {
          this.tabRef.select(Config.tab_menu_number.orderhistorypage);
      }
  }

  constructor(
      private _loc:Localization
  ) {
      let conf = JSON.parse(localStorage.getItem("configs"));
      this.useFixedLayout = (conf["MOBILEORDER_FIXED_LAYOUT"] && parseInt(conf["MOBILEORDER_FIXED_LAYOUT"]) > 0);

      this.showHistory = !Config.build_as_takeout;

      this.showCommerce = (conf['SPECIFIED_COMMERCIAL_TRANSACTION_HTML']) ? true : false;
      this.showResendMail = (conf['MOBILEORDER_RESEND_MAIL_TAB']) ? true : false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts